import { useTranslation } from 'react-i18next';
import React from 'react';
import { Namespace } from '../../../../translation/namespace';
import Btn, { BtnModifier } from '../../../../components/molecules/Btn';
import { InteractionStatus } from '../../../../types/InteractionStatus';
import { TooltipPlacement } from '../../../../components/atoms/Tooltip';
import { Icons } from '../../../../components/atoms/SVG';
import { SkipableContent } from '../SkipableContent';
import { GalleryImage } from '../GalleryImage';
import { GalleryHeadline } from '../GalleryHeadline';
import GalleryLoadingSpinner from '../GalleryLoadingSpinner';
import { SelectedImage } from '../../../../_lib/FileUpload';
import { isValid } from '../../../../_lib/FileUpload/utils/validateImage';
import { ImageList } from '../ImageList';
import { ImageListItem } from '../ImageListItem';

type UploadPreviewGalleryProps = {
  id: string;
  status?: string;
  showSpinner: boolean;
  selectedImages: SelectedImage[];
  removeImage(image: File): void;
};

export function UploadPreviewGallery({
  id,
  status,
  showSpinner,
  selectedImages,
  removeImage,
}: UploadPreviewGalleryProps) {
  const { t } = useTranslation(Namespace.ImageGallery);
  const images = selectedImages.filter(isValid);

  if (images.length === 0 && !showSpinner) return null;
  return (
    <>
      {showSpinner && (
        <div className="image-gallery__gray-out-on-upload">
          <GalleryLoadingSpinner />
        </div>
      )}
      <GalleryHeadline id={id}>{t('headlineSelectPreview')}</GalleryHeadline>
      <SkipableContent id={id}>
        <ImageList>
          {images.map(item => (
            <ImageListItem key={item.file.name}>
              {status === InteractionStatus.SENDING && <div className="image-gallery__gray-out-on-upload" />}
              <GalleryImage src={item.image.src} alt={item.file.name} />
              <div className="image-gallery__delete-button">
                <Btn
                  modifier={[BtnModifier.MINOR_ACTION, BtnModifier.TRANSPARENT]}
                  svgSpriteId={Icons.DELETE_X_SMALL}
                  type="button"
                  text={t('imageInteractions.remove.text', { fileName: item.file.name })}
                  titleText={t('imageInteractions.remove.title', { fileName: item.file.name })}
                  hiddenText
                  tooltipPlacement={TooltipPlacement.TOP}
                  disabled={status === InteractionStatus.SENDING}
                  onClick={() => removeImage(item.file)}
                />
              </div>
            </ImageListItem>
          ))}
        </ImageList>
      </SkipableContent>
    </>
  );
}
